export default "__VITE_ASSET__DTec31TU__"